import { action, computed, makeObservable, observable } from "mobx";
import { v4 } from 'uuid';
import { VariantExternalDataStore } from "./variantExternalData";

export class VariantStore {
    @observable id;
    @observable imageId = '';
    @observable availableInCatalog = true;
    @observable variationsIds = [];
    @observable typeSpecific = {
        repeat: null,
        allowedType: null,
        diffuseColor: null,
        specularColor: null,
        uSize: null,
        vSize: null,
        width: null,
        height: null
    };
    externalData;

    constructor(data) {
        makeObservable(this);
        if (data) {
            this.setId(data.id);
            this.setImageId(data.imageId);
            this.setAvailableInCatalog(data.availableInCatalog);
            this.variationsIds = observable.array(data.variationsIds);
            Object.keys(data.typeSpecific).forEach(key => this.setTypeSpecific(key, data.typeSpecific[key]));
            this.externalData = observable.array(data.externalData.map(externalData => new VariantExternalDataStore(externalData)));
        } else {
            this.setId(v4());
            this.externalData = observable.array();
        }
    }

    @computed get touchedExternalData() {
        return this.externalData.filter(({isTouched}) => isTouched);
    }

    @action.bound setId = (id) => this.id = id;
    @action.bound setImageId = (id) => this.imageId = id;
    @action.bound setAvailableInCatalog = (availableInCatalog) => this.availableInCatalog = availableInCatalog;
    @action.bound addExternalData = () => this.externalData.push(new VariantExternalDataStore());
    @action.bound removeExternalData = (url) => this.externalData.splice(this.externalData.findIndex(e => e.url === url), 1);

    @action.bound setTypeSpecific = (key, value) => {
        if ((value === "boolean" || value === 'number' && !value)) {
            delete this.typeSpecific[key];
        } else {
            this.typeSpecific[key] = value;
        }
    };
}
